import React, { useEffect, useState } from 'react';
import './appointmentSearch.css';
import Mapcomponent from './Mapcomponent';
import BreadCrum from '../features/breadcrum/BreadCrum';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FiltersBox from '../components/utilities/FiltersBox';
import { useDispatch } from 'react-redux';
import {
    loadMoreServices,
    searchServices,
} from '../redux/services/servicesActions';
import { Spin } from 'antd';
import { setSearchData } from '../redux/users/actionCreator';
import { toast } from 'react-toastify';
import { LOAD_MORE } from '../redux/services/servicesTypes';
import { businessAverageRating, formatDuration } from '../helpers/constants';

const AppointmentSearch = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [isFilteredByTransport, setIsFilteredByTransport] = useState(false);

    const { isLoading, isLoadingMore, page, searchPagination } = useSelector(
        (state) => state.services
    );
    const { searchData } = useSelector((state) => state.user);
    // console.log('searchPagination: ', searchPagination);

    const { searchedData } = useSelector((state) => state.services);
    const [locationList, setLocationList] = useState([]);
    const [toggleFilter, setToggleFilter] = useState(false);
    const [activeButton, setActiveButton] = useState(null);
    const [transMode, setTransMode] = useState('Transport Mode');
    const [searchPayload, setSearchPayload] = useState(searchData);
    const [hours, setHours] = useState('');
    const [minutes, setMinutes] = useState('');

    // useEffect(() => {
    //     if (hours.length === 2 && minutes.length === 2) {
    //         console.log('In hours and minuts');
    //         setSearchPayload((prevPayload) => ({
    //             ...prevPayload,
    //             duration: `${hours}:${minutes}`,
    //         }));
    //         console.log('Search data', searchData);
    //         dispatch(
    //             setSearchData({
    //                 ...searchData,
    //                 duration: `${hours}:${minutes}`,
    //             })
    //         );
    //     }
    // }, [hours, minutes]);

    // useEffect(() => {
    //     console.log(
    //         'Changed..',
    //         searchPayload.duration,
    //         searchPayload.mode,
    //         transMode
    //     );
    //     if (
    //         searchPayload.duration &&
    //         searchPayload.duration.includes(':') &&
    //         searchPayload.mode &&
    //         transMode != 'Transport Mode'
    //     ) {
    //         setTimeout(() => {
    //             dispatch(searchServices(searchPayload));
    //             dispatch(setSearchData(searchPayload));
    //         }, 2000);
    //     }
    // }, [searchPayload.duration, searchPayload.mode, transMode]);

    const handleTimeInput = (value, max, setter) => {
        if (
            value.match(/^\d{0,2}$/) &&
            (value === '' || parseInt(value, 10) <= max)
        ) {
            setter(value);
        }
    };

    const handleBlur = (setter, value, max) => {
        let formattedValue = value;
        if (value.length < 2 && value !== '') {
            formattedValue = value.padStart(2, '0');
            setter(formattedValue);
        } else if (value === '') {
            setter('');
        }
    };

    const handleMode = (name, value) => {
        setTransMode(name);
        setSearchPayload((prevPayload) => ({
            ...prevPayload,
            mode: value,
        }));
    };

    useEffect(() => {
        // setHours(searchData?.duration?.substring(0, 2) || '');
        // setMinutes(searchData?.duration?.substring(0, 2) || '');
        if (searchData?.duration?.includes(':')) {
            let splittedDuration = searchData?.duration.split(':');
            console.log('splitted', splittedDuration);
            setHours(splittedDuration[0]);
            setMinutes(splittedDuration[1]);
        } else {
            setHours('');
            setMinutes('');
            setIsFilteredByTransport(false);
        }

        if (searchData?.mode) {
            if (searchData?.mode == 'Driving') {
                setTransMode('Car');
            } else if (searchData?.mode == 'Transit') {
                setTransMode('Public Transport');
            } else if (searchData?.mode == 'Walking') {
                setTransMode('Walk');
            }
        } else {
            setTransMode('Transport Mode');
            setIsFilteredByTransport(false);
        }
    }, [searchData]);

    useEffect(() => {
        const latLngArray = searchedData?.map(({ latitude, longitude }) => ({
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
        }));

        setLocationList(latLngArray);
    }, [searchedData]);

    const handleFilter = (type) => {
        setActiveButton(type);
        setSearchPayload((prevPayload) => ({
            ...prevPayload,
            filter: type,
        }));
    };

    const handlePrice = (e) => {
        const value = e.target.value;
        setSearchPayload((prevPayload) => ({
            ...prevPayload,
            price: Number(value) || '',
        }));
    };

    const handleDistance = (e) => {
        const value = e.target.value;
        setSearchPayload((prevPayload) => ({
            ...prevPayload,
            distance: Number(value) || '',
        }));
    };

    const handleSubmitFilter = () => {
        if (
            searchPayload.filter ||
            searchPayload.price ||
            searchPayload.distance
        ) {
            setToggleFilter(false);
            let obj = {
                ...searchPayload,
            };
            if (isFilteredByTransport) {
                obj = {
                    ...obj,
                    duration: `${hours}:${minutes}`,
                    mode: transMode,
                };
            }
            dispatch(setSearchData(searchPayload));
            dispatch(searchServices(obj));
        }
    };

    const clearFilter = () => {
        if (searchData && 'filter' in searchData) {
            delete searchData.filter;
            delete searchData.price;
            delete searchData.distance;
            setToggleFilter(false);
            let obj = {
                ...searchData,
            };
            if (isFilteredByTransport) {
                obj = {
                    ...obj,
                    duration: `${hours}:${minutes}`,
                    mode: transMode,
                };
            }
            dispatch(searchServices(obj));
        }
        setSearchPayload((prevPayload) => ({
            ...prevPayload,
            filter: '',
            distance: '',
            price: '',
        }));
        setActiveButton(null);
    };

    const cancelFilter = (type) => {
        setSearchPayload((prevPayload) => ({
            ...prevPayload,
            [type]: '',
        }));
        delete searchData[type];
        if (type === 'filter') {
            setActiveButton(null);
        }
        dispatch(searchServices(searchData));
    };

    useEffect(() => {
        setSearchPayload(searchData);
        if (!searchData.filter) {
            setActiveButton(null);
        }
    }, [searchData]);

    useEffect(() => {
        if (page > 1) {
            let tempObj = {
                ...searchData,
            };
            if (isFilteredByTransport) {
                tempObj = {
                    ...searchData,
                    duration: `${hours}:${minutes}`,
                    mode: searchData.mode,
                };
            }
            dispatch(loadMoreServices({ ...tempObj, page: page }));
        }
    }, [page]);

    const displayClear = () => {
        if (isFilteredByTransport || searchData.mode) {
            return true;
        } else {
            return false;
        }
        // if (
        //     searchPayload.duration &&
        //     searchPayload.duration.includes(':') &&
        //     searchPayload.mode &&
        //     transMode != 'Transport Mode'
        // ) {
        //     setTimeout(() => {
        //         return true;
        //     }, 2000);
        //     return true;
        // } else {
        //     return false;
        // }
    };

    const handleTransportFilter = () => {
        if (transMode == 'Transport Mode') {
            toast.warning('Please select transport mode');
        } else if (hours.length == 0 || minutes.length == 0) {
            toast.warning('hours and minutes are required');
        } else {
            console.log('In filter step', searchData);

            dispatch(
                setSearchData({
                    ...searchData,
                    duration: `${hours}:${minutes}`,
                    mode: searchPayload.mode,
                })
            );

            dispatch(
                searchServices({
                    ...searchData,
                    duration: `${hours}:${minutes}`,
                    mode: searchPayload.mode,
                })
            );

            setIsFilteredByTransport(true);
        }
    };

    const clearTransportFilter = () => {
        let obj = {
            ...searchPayload,
        };
        // Remove duration and mode keys if they exist
        delete obj.duration;
        delete obj.mode;
        setHours('');
        setMinutes('');
        setTransMode('Transport Mode');
        setIsFilteredByTransport(false);

        setSearchPayload((prevPayload) => ({
            ...obj,
        }));
        dispatch(searchServices(obj));
        dispatch(setSearchData(obj));
    };

    return (
        <>
            <div className="container mt-3">
                <BreadCrum
                    items={[
                        { title: 'Home', path: '/home' },
                        {
                            title: 'Appointments Search',
                            path: '/appointment-search',
                        },
                    ]}
                />
            </div>
            <div className="container mt-5">
                <div className="row">
                    <div className=" d-flex flex-column col-12 col-lg-7">
                        {isLoading ? (
                            <Spin />
                        ) : (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-3">
                                        <div className="filter-trans btn-group">
                                            <button
                                                type="button"
                                                className="btn-dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                disabled={
                                                    isFilteredByTransport ||
                                                    searchData.mode
                                                }
                                            >
                                                {transMode}
                                                <svg
                                                    width="24"
                                                    height="25"
                                                    viewBox="0 0 24 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7 10.5L12 15.5L17 10.5H7Z"
                                                        fill="#667085"
                                                    />
                                                </svg>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li
                                                    className="dropdown-item px-0 py-1"
                                                    onClick={() =>
                                                        handleMode(
                                                            'Car',
                                                            'Driving'
                                                        )
                                                    }
                                                >
                                                    <svg
                                                        width="18"
                                                        height="14"
                                                        viewBox="0 0 18 14"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M16.875 5.875H16.1156L14.1623 1.48047C14.0739 1.28164 13.9298 1.11272 13.7473 0.994163C13.5649 0.875605 13.352 0.812503 13.1344 0.8125H4.86562C4.64804 0.812503 4.43512 0.875605 4.25266 0.994163C4.07021 1.11272 3.92605 1.28164 3.83766 1.48047L1.88437 5.875H1.125C0.975816 5.875 0.832742 5.93426 0.727252 6.03975C0.621763 6.14524 0.5625 6.28832 0.5625 6.4375C0.5625 6.58668 0.621763 6.72976 0.727252 6.83525C0.832742 6.94074 0.975816 7 1.125 7H1.6875V12.625C1.6875 12.9234 1.80603 13.2095 2.017 13.4205C2.22798 13.6315 2.51413 13.75 2.8125 13.75H4.5C4.79837 13.75 5.08452 13.6315 5.2955 13.4205C5.50647 13.2095 5.625 12.9234 5.625 12.625V11.5H12.375V12.625C12.375 12.9234 12.4935 13.2095 12.7045 13.4205C12.9155 13.6315 13.2016 13.75 13.5 13.75H15.1875C15.4859 13.75 15.772 13.6315 15.983 13.4205C16.194 13.2095 16.3125 12.9234 16.3125 12.625V7H16.875C17.0242 7 17.1673 6.94074 17.2727 6.83525C17.3782 6.72976 17.4375 6.58668 17.4375 6.4375C17.4375 6.28832 17.3782 6.14524 17.2727 6.03975C17.1673 5.93426 17.0242 5.875 16.875 5.875ZM4.86562 1.9375H13.1344L14.8845 5.875H3.11555L4.86562 1.9375ZM4.5 12.625H2.8125V11.5H4.5V12.625ZM13.5 12.625V11.5H15.1875V12.625H13.5ZM15.1875 10.375H2.8125V7H15.1875V10.375ZM3.9375 8.6875C3.9375 8.53832 3.99676 8.39524 4.10225 8.28975C4.20774 8.18426 4.35082 8.125 4.5 8.125H5.625C5.77418 8.125 5.91726 8.18426 6.02275 8.28975C6.12824 8.39524 6.1875 8.53832 6.1875 8.6875C6.1875 8.83668 6.12824 8.97976 6.02275 9.08525C5.91726 9.19074 5.77418 9.25 5.625 9.25H4.5C4.35082 9.25 4.20774 9.19074 4.10225 9.08525C3.99676 8.97976 3.9375 8.83668 3.9375 8.6875ZM11.8125 8.6875C11.8125 8.53832 11.8718 8.39524 11.9773 8.28975C12.0827 8.18426 12.2258 8.125 12.375 8.125H13.5C13.6492 8.125 13.7923 8.18426 13.8977 8.28975C14.0032 8.39524 14.0625 8.53832 14.0625 8.6875C14.0625 8.83668 14.0032 8.97976 13.8977 9.08525C13.7923 9.19074 13.6492 9.25 13.5 9.25H12.375C12.2258 9.25 12.0827 9.19074 11.9773 9.08525C11.8718 8.97976 11.8125 8.83668 11.8125 8.6875Z"
                                                            fill="#8D9CB0"
                                                        />
                                                    </svg>
                                                    <span>Car</span>
                                                </li>

                                                <li className="dropdown-divider"></li>

                                                <li
                                                    className="dropdown-item px-0 py-1"
                                                    onClick={() =>
                                                        handleMode(
                                                            'Walk',
                                                            'Walking'
                                                        )
                                                    }
                                                >
                                                    <svg
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M11.2499 2.8125C11.2499 2.36749 11.1179 1.93248 10.8707 1.56247C10.6234 1.19246 10.272 0.904069 9.8609 0.733772C9.44977 0.563475 8.99737 0.518917 8.56091 0.605734C8.12445 0.692551 7.72354 0.906843 7.40887 1.22151C7.0942 1.53618 6.87991 1.93709 6.7931 2.37355C6.70628 2.81001 6.75084 3.2624 6.92113 3.67354C7.09143 4.08467 7.37982 4.43607 7.74983 4.68331C8.11984 4.93054 8.55485 5.0625 8.99986 5.0625C9.5966 5.0625 10.1689 4.82545 10.5909 4.40349C11.0128 3.98153 11.2499 3.40924 11.2499 2.8125ZM8.99986 3.9375C8.77736 3.9375 8.55985 3.87152 8.37485 3.7479C8.18984 3.62429 8.04565 3.44859 7.9605 3.24302C7.87535 3.03745 7.85307 2.81125 7.89648 2.59302C7.93989 2.3748 8.04703 2.17434 8.20437 2.01701C8.3617 1.85967 8.56216 1.75253 8.78039 1.70912C8.99862 1.66571 9.22482 1.68799 9.43038 1.77314C9.63595 1.85829 9.81165 2.00248 9.93527 2.18748C10.0589 2.37249 10.1249 2.59 10.1249 2.8125C10.1249 3.11087 10.0063 3.39702 9.79536 3.608C9.58438 3.81897 9.29823 3.9375 8.99986 3.9375ZM15.3519 9.42539L12.1759 5.82399C11.9647 5.58462 11.705 5.39293 11.4141 5.26164C11.1231 5.13035 10.8076 5.06247 10.4884 5.0625H7.51135C7.19215 5.06247 6.8766 5.13035 6.58565 5.26164C6.2947 5.39293 6.03502 5.58462 5.82385 5.82399L2.64783 9.42539C2.38991 9.68918 2.24598 10.0438 2.24708 10.4127C2.24817 10.7816 2.39421 11.1353 2.65369 11.3976C2.91318 11.6598 3.26533 11.8096 3.63423 11.8146C4.00312 11.8196 4.35921 11.6795 4.62572 11.4244L5.77182 10.5047L4.60885 14.9259C4.45482 15.2658 4.4421 15.6529 4.5735 16.0022C4.7049 16.3514 4.96965 16.6341 5.30951 16.7882C5.64937 16.9422 6.0365 16.9549 6.38574 16.8235C6.73497 16.6921 7.01771 16.4274 7.17174 16.0875L8.99986 12.9326L10.828 16.0875C10.9889 16.416 11.2715 16.6688 11.6157 16.7924C11.9599 16.9159 12.3388 16.9005 12.6719 16.7494C13.0049 16.5983 13.266 16.3233 13.3997 15.9829C13.5335 15.6425 13.5293 15.2633 13.3881 14.9259L12.2279 10.5047L13.374 11.4244C13.6405 11.6795 13.9966 11.8196 14.3655 11.8146C14.7344 11.8096 15.0865 11.6598 15.346 11.3976C15.6055 11.1353 15.7516 10.7816 15.7526 10.4127C15.7537 10.0438 15.6098 9.68918 15.3519 9.42539ZM14.5426 10.6045C14.5165 10.6307 14.4855 10.6514 14.4513 10.6656C14.4172 10.6797 14.3806 10.687 14.3436 10.687C14.3067 10.687 14.2701 10.6797 14.2359 10.6656C14.2018 10.6514 14.1707 10.6307 14.1446 10.6045C14.1299 10.5905 14.1151 10.5764 14.0989 10.5638L11.6014 8.56125C11.5093 8.48768 11.3963 8.44493 11.2785 8.43906C11.1607 8.43319 11.044 8.4645 10.945 8.52855C10.846 8.5926 10.7696 8.68615 10.7266 8.79599C10.6837 8.90583 10.6763 9.02639 10.7056 9.14063L12.3144 15.2578C12.3227 15.2904 12.334 15.3222 12.3481 15.3527C12.3644 15.3863 12.3738 15.4227 12.3758 15.46C12.3778 15.4972 12.3724 15.5344 12.3599 15.5695C12.3474 15.6046 12.3281 15.6369 12.303 15.6645C12.2779 15.6921 12.2476 15.7144 12.2138 15.7301C12.18 15.7459 12.1434 15.7547 12.1062 15.7562C12.069 15.7577 12.0318 15.7518 11.9969 15.7388C11.9619 15.7258 11.9299 15.706 11.9027 15.6805C11.8755 15.655 11.8536 15.6244 11.8384 15.5904C11.8315 15.5752 11.8237 15.5604 11.8152 15.5461L9.48643 11.5313C9.43698 11.446 9.36601 11.3753 9.28061 11.3261C9.19522 11.2769 9.09841 11.251 8.99986 11.251C8.90132 11.251 8.8045 11.2769 8.71911 11.3261C8.63372 11.3753 8.56275 11.446 8.5133 11.5313L6.18736 15.5426C6.17879 15.5569 6.17105 15.5717 6.16416 15.5869C6.14854 15.6204 6.12647 15.6505 6.0992 15.6755C6.07193 15.7004 6.04001 15.7198 6.00525 15.7324C5.95295 15.7516 5.89613 15.7548 5.84201 15.7416C5.78788 15.7285 5.73888 15.6995 5.70122 15.6585C5.66356 15.6174 5.63894 15.5661 5.63048 15.5111C5.62202 15.456 5.6301 15.3997 5.65369 15.3492C5.66786 15.3187 5.67916 15.2869 5.68744 15.2543L7.29408 9.14063C7.32338 9.02639 7.31604 8.90583 7.27308 8.79599C7.23013 8.68615 7.15374 8.5926 7.05471 8.52855C6.95568 8.4645 6.83902 8.43319 6.72123 8.43906C6.60344 8.44493 6.49047 8.48768 6.3983 8.56125L3.9008 10.5638C3.88463 10.5764 3.86986 10.5905 3.8551 10.6045C3.82926 10.6318 3.79824 10.6536 3.76385 10.6686C3.72947 10.6837 3.69241 10.6917 3.65488 10.6922C3.61734 10.6927 3.58008 10.6857 3.54529 10.6716C3.51051 10.6575 3.4789 10.6366 3.45233 10.61C3.42576 10.5835 3.40477 10.5519 3.3906 10.5172C3.37642 10.4824 3.36935 10.4452 3.3698 10.4076C3.37025 10.3701 3.3782 10.333 3.3932 10.2986C3.4082 10.2642 3.42994 10.2331 3.45713 10.2073C3.46557 10.1988 3.4733 10.1904 3.48103 10.1813L6.6676 6.56789C6.77321 6.44827 6.90307 6.35249 7.04854 6.28691C7.19402 6.22133 7.35178 6.18744 7.51135 6.1875H10.4884C10.648 6.18744 10.8057 6.22133 10.9512 6.28691C11.0967 6.35249 11.2265 6.44827 11.3321 6.56789L14.5187 10.1813C14.5264 10.1904 14.5342 10.1988 14.5426 10.2073C14.5952 10.26 14.6247 10.3314 14.6247 10.4059C14.6247 10.4804 14.5952 10.5518 14.5426 10.6045Z"
                                                            fill="#8D9CB0"
                                                        />
                                                    </svg>
                                                    <span>Walk</span>
                                                </li>

                                                <li className="dropdown-divider"></li>

                                                <li
                                                    className="dropdown-item px-0 py-1"
                                                    onClick={() =>
                                                        handleMode(
                                                            'Public Transport',
                                                            'Transit'
                                                        )
                                                    }
                                                >
                                                    <svg
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12.9375 1.6875H5.0625C4.46576 1.6875 3.89347 1.92455 3.47151 2.34651C3.04955 2.76847 2.8125 3.34076 2.8125 3.9375V12.9375C2.8125 13.5342 3.04955 14.1065 3.47151 14.5285C3.89347 14.9504 4.46576 15.1875 5.0625 15.1875H5.625L4.6125 16.5375C4.56818 16.5966 4.53593 16.6638 4.5176 16.7354C4.49927 16.807 4.49521 16.8814 4.50565 16.9545C4.5161 17.0277 4.54085 17.098 4.57848 17.1616C4.61612 17.2252 4.6659 17.2807 4.725 17.325C4.78409 17.3693 4.85134 17.4016 4.9229 17.4199C4.99446 17.4382 5.06892 17.4423 5.14205 17.4318C5.21518 17.4214 5.28553 17.3967 5.34909 17.359C5.41265 17.3214 5.46818 17.2716 5.5125 17.2125L7.03125 15.1875H10.9688L12.4875 17.2125C12.577 17.3318 12.7103 17.4107 12.858 17.4318C13.0056 17.4529 13.1557 17.4145 13.275 17.325C13.3943 17.2355 13.4732 17.1022 13.4943 16.9545C13.5154 16.8069 13.477 16.6568 13.3875 16.5375L12.375 15.1875H12.9375C13.5342 15.1875 14.1065 14.9504 14.5285 14.5285C14.9504 14.1065 15.1875 13.5342 15.1875 12.9375V3.9375C15.1875 3.34076 14.9504 2.76847 14.5285 2.34651C14.1065 1.92455 13.5342 1.6875 12.9375 1.6875ZM3.9375 8.4375V5.625H8.4375V8.4375H3.9375ZM9.5625 5.625H14.0625V8.4375H9.5625V5.625ZM5.0625 2.8125H12.9375C13.2359 2.8125 13.522 2.93103 13.733 3.142C13.944 3.35298 14.0625 3.63913 14.0625 3.9375V4.5H3.9375V3.9375C3.9375 3.63913 4.05603 3.35298 4.267 3.142C4.47798 2.93103 4.76413 2.8125 5.0625 2.8125ZM12.9375 14.0625H5.0625C4.76413 14.0625 4.47798 13.944 4.267 13.733C4.05603 13.522 3.9375 13.2359 3.9375 12.9375V9.5625H14.0625V12.9375C14.0625 13.2359 13.944 13.522 13.733 13.733C13.522 13.944 13.2359 14.0625 12.9375 14.0625ZM6.75 12.0938C6.75 12.2606 6.70052 12.4238 6.6078 12.5625C6.51509 12.7013 6.38331 12.8094 6.22914 12.8733C6.07496 12.9371 5.90531 12.9538 5.74164 12.9213C5.57797 12.8887 5.42763 12.8084 5.30963 12.6904C5.19163 12.5724 5.11127 12.422 5.07871 12.2584C5.04616 12.0947 5.06287 11.925 5.12673 11.7709C5.19059 11.6167 5.29873 11.4849 5.43749 11.3922C5.57624 11.2995 5.73937 11.25 5.90625 11.25C6.13003 11.25 6.34464 11.3389 6.50287 11.4971C6.66111 11.6554 6.75 11.87 6.75 12.0938ZM12.9375 12.0938C12.9375 12.2606 12.888 12.4238 12.7953 12.5625C12.7026 12.7013 12.5708 12.8094 12.4166 12.8733C12.2625 12.9371 12.0928 12.9538 11.9291 12.9213C11.7655 12.8887 11.6151 12.8084 11.4971 12.6904C11.3791 12.5724 11.2988 12.422 11.2662 12.2584C11.2337 12.0947 11.2504 11.925 11.3142 11.7709C11.3781 11.6167 11.4862 11.4849 11.625 11.3922C11.7637 11.2995 11.9269 11.25 12.0938 11.25C12.3175 11.25 12.5321 11.3389 12.6904 11.4971C12.8486 11.6554 12.9375 11.87 12.9375 12.0938Z"
                                                            fill="#8D9CB0"
                                                        />
                                                    </svg>
                                                    <span>
                                                        Public Transport
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="filter-transtime">
                                            <span>Max Travel Time</span>
                                            <div className="inputBox">
                                                <input
                                                    style={{ width: 21 }}
                                                    type="text"
                                                    value={hours}
                                                    placeholder="hh"
                                                    disabled={
                                                        isFilteredByTransport ||
                                                        searchData.mode
                                                    }
                                                    // disabled={
                                                    //     !searchPayload.mode
                                                    // }
                                                    onChange={(e) =>
                                                        handleTimeInput(
                                                            e.target.value,
                                                            23,
                                                            setHours
                                                        )
                                                    }
                                                    onBlur={() =>
                                                        handleBlur(
                                                            setHours,
                                                            hours,
                                                            23
                                                        )
                                                    }
                                                    onFocus={(e) =>
                                                        e.target.select()
                                                    }
                                                />
                                                <span>:</span>
                                                <input
                                                    style={{ width: 32 }}
                                                    type="text"
                                                    value={minutes}
                                                    placeholder="mm"
                                                    disabled={
                                                        isFilteredByTransport ||
                                                        searchData.mode
                                                    }
                                                    // disabled={
                                                    //     !searchPayload.mode
                                                    // }
                                                    onChange={(e) =>
                                                        handleTimeInput(
                                                            e.target.value,
                                                            59,
                                                            setMinutes
                                                        )
                                                    }
                                                    onBlur={() =>
                                                        handleBlur(
                                                            setMinutes,
                                                            minutes,
                                                            59
                                                        )
                                                    }
                                                    onFocus={(e) =>
                                                        e.target.select()
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {displayClear() ? (
                                            <button
                                                type="button"
                                                className="f-16 poppins text-white booking-btn clear-btn"
                                                onClick={clearTransportFilter}
                                            >
                                                Clear
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="f-16 poppins text-white  transport-filter-btn "
                                                onClick={handleTransportFilter}
                                            >
                                                Journey Time
                                            </button>
                                        )}

                                        {/* <a
                                            class="link-opacity-75-hover poppins f-12 mr-2"
                                            onClick={clearFilter}
                                        >
                                            Remove travel filter
                                        </a> */}
                                    </div>

                                    <FiltersBox
                                        toggleFilter={toggleFilter}
                                        setToggleFilter={setToggleFilter}
                                        searchPayload={searchPayload}
                                        setSearchPayload={setSearchPayload}
                                        handleFilter={handleFilter}
                                        handlePrice={handlePrice}
                                        handleDistance={handleDistance}
                                        handleSubmitFilter={handleSubmitFilter}
                                        activeButton={activeButton}
                                        clearFilter={clearFilter}
                                    />
                                </div>

                                <h6 className="c-667085 poppins f-14 fw-400">
                                    {searchedData?.length} Venues nearby
                                </h6>

                                {(searchData.filter ||
                                    searchData.price ||
                                    searchData.distance) && (
                                        <div
                                            className="d-flex justify-content-between align-items-center px-4 py-2 mb-3"
                                            style={{ background: '#e2e6ee' }}
                                        >
                                            <div className="d-flex gap-md-3">
                                                {searchData.filter && (
                                                    <span
                                                        className="d-flex gap-2 align-items-center poppins f-12 fw-600 rounded p-1"
                                                        style={{
                                                            border: '1px solid #d6dae2',
                                                        }}
                                                    >
                                                        Sort By: {searchData.filter}
                                                        <svg
                                                            className="cp"
                                                            onClick={() =>
                                                                cancelFilter(
                                                                    'filter'
                                                                )
                                                            }
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <rect
                                                                x="0.3"
                                                                y="0.3"
                                                                width="23.4"
                                                                height="23.4"
                                                                rx="11.7"
                                                                fill="white"
                                                            />
                                                            <rect
                                                                x="0.3"
                                                                y="0.3"
                                                                width="23.4"
                                                                height="23.4"
                                                                rx="11.7"
                                                                stroke="#E1E6EF"
                                                                stroke-width="0.6"
                                                            />
                                                            <path
                                                                d="M15.6405 15.1099C15.6754 15.1447 15.703 15.1861 15.7219 15.2316C15.7407 15.2771 15.7504 15.3259 15.7504 15.3752C15.7504 15.4245 15.7407 15.4733 15.7219 15.5188C15.703 15.5643 15.6754 15.6057 15.6405 15.6405C15.6057 15.6754 15.5643 15.703 15.5188 15.7219C15.4733 15.7407 15.4245 15.7504 15.3752 15.7504C15.3259 15.7504 15.2771 15.7407 15.2316 15.7219C15.1861 15.703 15.1447 15.6754 15.1099 15.6405L12.0002 12.5304L8.89052 15.6405C8.82016 15.7109 8.72472 15.7504 8.62521 15.7504C8.5257 15.7504 8.43026 15.7109 8.3599 15.6405C8.28953 15.5702 8.25 15.4747 8.25 15.3752C8.25 15.2757 8.28953 15.1803 8.3599 15.1099L11.4701 12.0002L8.3599 8.89052C8.28953 8.82016 8.25 8.72472 8.25 8.62521C8.25 8.5257 8.28953 8.43026 8.3599 8.3599C8.43026 8.28953 8.5257 8.25 8.62521 8.25C8.72472 8.25 8.82016 8.28953 8.89052 8.3599L12.0002 11.4701L15.1099 8.3599C15.1803 8.28953 15.2757 8.25 15.3752 8.25C15.4747 8.25 15.5702 8.28953 15.6405 8.3599C15.7109 8.43026 15.7504 8.5257 15.7504 8.62521C15.7504 8.72472 15.7109 8.82016 15.6405 8.89052L12.5304 12.0002L15.6405 15.1099Z"
                                                                fill="black"
                                                            />
                                                        </svg>
                                                    </span>
                                                )}
                                                {searchData.price && (
                                                    <span
                                                        className="d-flex gap-2 align-items-center poppins f-12 fw-600 rounded p-1"
                                                        style={{
                                                            border: '1px solid #d6dae2',
                                                        }}
                                                    >
                                                        Max Price: £
                                                        {searchData.price}
                                                        <svg
                                                            className="cp"
                                                            onClick={() =>
                                                                cancelFilter(
                                                                    'price'
                                                                )
                                                            }
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <rect
                                                                x="0.3"
                                                                y="0.3"
                                                                width="23.4"
                                                                height="23.4"
                                                                rx="11.7"
                                                                fill="white"
                                                            />
                                                            <rect
                                                                x="0.3"
                                                                y="0.3"
                                                                width="23.4"
                                                                height="23.4"
                                                                rx="11.7"
                                                                stroke="#E1E6EF"
                                                                stroke-width="0.6"
                                                            />
                                                            <path
                                                                d="M15.6405 15.1099C15.6754 15.1447 15.703 15.1861 15.7219 15.2316C15.7407 15.2771 15.7504 15.3259 15.7504 15.3752C15.7504 15.4245 15.7407 15.4733 15.7219 15.5188C15.703 15.5643 15.6754 15.6057 15.6405 15.6405C15.6057 15.6754 15.5643 15.703 15.5188 15.7219C15.4733 15.7407 15.4245 15.7504 15.3752 15.7504C15.3259 15.7504 15.2771 15.7407 15.2316 15.7219C15.1861 15.703 15.1447 15.6754 15.1099 15.6405L12.0002 12.5304L8.89052 15.6405C8.82016 15.7109 8.72472 15.7504 8.62521 15.7504C8.5257 15.7504 8.43026 15.7109 8.3599 15.6405C8.28953 15.5702 8.25 15.4747 8.25 15.3752C8.25 15.2757 8.28953 15.1803 8.3599 15.1099L11.4701 12.0002L8.3599 8.89052C8.28953 8.82016 8.25 8.72472 8.25 8.62521C8.25 8.5257 8.28953 8.43026 8.3599 8.3599C8.43026 8.28953 8.5257 8.25 8.62521 8.25C8.72472 8.25 8.82016 8.28953 8.89052 8.3599L12.0002 11.4701L15.1099 8.3599C15.1803 8.28953 15.2757 8.25 15.3752 8.25C15.4747 8.25 15.5702 8.28953 15.6405 8.3599C15.7109 8.43026 15.7504 8.5257 15.7504 8.62521C15.7504 8.72472 15.7109 8.82016 15.6405 8.89052L12.5304 12.0002L15.6405 15.1099Z"
                                                                fill="black"
                                                            />
                                                        </svg>
                                                    </span>
                                                )}
                                                {searchData.distance && (
                                                    <span
                                                        className="d-flex gap-2 align-items-center poppins f-12 fw-600 rounded p-1"
                                                        style={{
                                                            border: '1px solid #d6dae2',
                                                        }}
                                                    >
                                                        Distance:{' '}
                                                        {searchData.distance}km
                                                        <svg
                                                            className="cp"
                                                            onClick={() =>
                                                                cancelFilter(
                                                                    'distance'
                                                                )
                                                            }
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <rect
                                                                x="0.3"
                                                                y="0.3"
                                                                width="23.4"
                                                                height="23.4"
                                                                rx="11.7"
                                                                fill="white"
                                                            />
                                                            <rect
                                                                x="0.3"
                                                                y="0.3"
                                                                width="23.4"
                                                                height="23.4"
                                                                rx="11.7"
                                                                stroke="#E1E6EF"
                                                                stroke-width="0.6"
                                                            />
                                                            <path
                                                                d="M15.6405 15.1099C15.6754 15.1447 15.703 15.1861 15.7219 15.2316C15.7407 15.2771 15.7504 15.3259 15.7504 15.3752C15.7504 15.4245 15.7407 15.4733 15.7219 15.5188C15.703 15.5643 15.6754 15.6057 15.6405 15.6405C15.6057 15.6754 15.5643 15.703 15.5188 15.7219C15.4733 15.7407 15.4245 15.7504 15.3752 15.7504C15.3259 15.7504 15.2771 15.7407 15.2316 15.7219C15.1861 15.703 15.1447 15.6754 15.1099 15.6405L12.0002 12.5304L8.89052 15.6405C8.82016 15.7109 8.72472 15.7504 8.62521 15.7504C8.5257 15.7504 8.43026 15.7109 8.3599 15.6405C8.28953 15.5702 8.25 15.4747 8.25 15.3752C8.25 15.2757 8.28953 15.1803 8.3599 15.1099L11.4701 12.0002L8.3599 8.89052C8.28953 8.82016 8.25 8.72472 8.25 8.62521C8.25 8.5257 8.28953 8.43026 8.3599 8.3599C8.43026 8.28953 8.5257 8.25 8.62521 8.25C8.72472 8.25 8.82016 8.28953 8.89052 8.3599L12.0002 11.4701L15.1099 8.3599C15.1803 8.28953 15.2757 8.25 15.3752 8.25C15.4747 8.25 15.5702 8.28953 15.6405 8.3599C15.7109 8.43026 15.7504 8.5257 15.7504 8.62521C15.7504 8.72472 15.7109 8.82016 15.6405 8.89052L12.5304 12.0002L15.6405 15.1099Z"
                                                                fill="black"
                                                            />
                                                        </svg>
                                                    </span>
                                                )}
                                            </div>
                                            <a
                                                class="link-opacity-75-hover poppins f-12"
                                                onClick={clearFilter}
                                            >
                                                Remove all filters
                                            </a>
                                        </div>
                                    )}

                                {searchedData &&
                                    searchedData.length > 0 &&
                                    searchedData?.map((item, index) => (
                                        <div
                                            className="row mb-4 pb-4 border-bottom cp"
                                            key={index}
                                            onClick={() =>
                                                history.push(
                                                    `/business-details/${item?.id}`
                                                )
                                            }
                                        >
                                            <img
                                                className="container-content-img col-md-5  col-12"
                                                src={
                                                    item?.pictures[0]
                                                        ?.photo_path
                                                }
                                                alt="card img"
                                            />
                                            <div className="overflow-hidden col-md-7  col-12">
                                                <div className="d-flex justify-content-between align-items-center mt-md-0 mt-2">
                                                    <div className="poppins fw-bold">
                                                        {item.name}
                                                    </div>
                                                    <div className="d-flex justify-content-center align-items-center gap-1 text-center color-primary">
                                                        <span className="f-14 poppins">
                                                            {businessAverageRating(
                                                                item?.reviews ||
                                                                []
                                                            )}
                                                        </span>
                                                        <span className="px-1 d-flex">
                                                            <svg
                                                                width="12"
                                                                height="12"
                                                                viewBox="0 0 12 12"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <g clipPath="url(#clip0_252_296)">
                                                                    <path
                                                                        d="M2.44884 11.6623C2.40084 11.6623 2.35284 11.6383 2.30484 11.6143C2.23284 11.5663 2.18484 11.4463 2.20884 11.3503L3.26484 7.41428L0.0968438 4.84628C0.000843818 4.79828 -0.0231562 4.67828 0.000843815 4.58228C0.0248438 4.48628 0.120844 4.41428 0.216844 4.41428L4.29684 4.19828L5.76084 0.382281C5.80884 0.310281 5.90484 0.238281 6.00084 0.238281C6.09684 0.238281 6.19284 0.310281 6.21684 0.382281L7.68084 4.19828L11.7608 4.41428C11.8568 4.41428 11.9528 4.48628 11.9768 4.58228C12.0008 4.67828 11.9768 4.77428 11.9048 4.84628L8.73684 7.41428L9.79284 11.3503C9.81684 11.4463 9.79284 11.5423 9.69684 11.6143C9.62484 11.6623 9.50484 11.6863 9.43284 11.6143L6.00084 9.40628L2.56884 11.6143C2.52084 11.6623 2.49684 11.6623 2.44884 11.6623Z"
                                                                        fill="#2b5c35"
                                                                    />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_252_296">
                                                                        <rect
                                                                            width="12"
                                                                            height="12"
                                                                            fill="white"
                                                                        />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </span>
                                                        <span className="poppins">
                                                            (
                                                            {item?.reviews
                                                                ?.length || 0}
                                                            )
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    className="pt-1
                     poppins c-667085"
                                                >
                                                    <p
                                                        className="search_address mb-0"
                                                        title={item.address}
                                                    >
                                                        {item.address}
                                                    </p>
                                                </div>
                                                <div className="d-flex py-3 pt-md-2 gap-2 flex-wrap">
                                                    <div className="border-card-pill">
                                                        <div className="py-1 px-2">
                                                            <span>
                                                                <svg
                                                                    width="18"
                                                                    height="14"
                                                                    viewBox="0 0 18 14"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M16.875 5.375H16.1156L14.1623 0.980469C14.0739 0.781644 13.9298 0.61272 13.7473 0.494163C13.5649 0.375605 13.352 0.312503 13.1344 0.3125H4.86562C4.64804 0.312503 4.43512 0.375605 4.25266 0.494163C4.07021 0.61272 3.92605 0.781644 3.83766 0.980469L1.88437 5.375H1.125C0.975816 5.375 0.832742 5.43426 0.727252 5.53975C0.621763 5.64524 0.5625 5.78832 0.5625 5.9375C0.5625 6.08668 0.621763 6.22976 0.727252 6.33525C0.832742 6.44074 0.975816 6.5 1.125 6.5H1.6875V12.125C1.6875 12.4234 1.80603 12.7095 2.017 12.9205C2.22798 13.1315 2.51413 13.25 2.8125 13.25H4.5C4.79837 13.25 5.08452 13.1315 5.2955 12.9205C5.50647 12.7095 5.625 12.4234 5.625 12.125V11H12.375V12.125C12.375 12.4234 12.4935 12.7095 12.7045 12.9205C12.9155 13.1315 13.2016 13.25 13.5 13.25H15.1875C15.4859 13.25 15.772 13.1315 15.983 12.9205C16.194 12.7095 16.3125 12.4234 16.3125 12.125V6.5H16.875C17.0242 6.5 17.1673 6.44074 17.2727 6.33525C17.3782 6.22976 17.4375 6.08668 17.4375 5.9375C17.4375 5.78832 17.3782 5.64524 17.2727 5.53975C17.1673 5.43426 17.0242 5.375 16.875 5.375ZM4.86562 1.4375H13.1344L14.8845 5.375H3.11555L4.86562 1.4375ZM4.5 12.125H2.8125V11H4.5V12.125ZM13.5 12.125V11H15.1875V12.125H13.5ZM15.1875 9.875H2.8125V6.5H15.1875V9.875ZM3.9375 8.1875C3.9375 8.03832 3.99676 7.89524 4.10225 7.78975C4.20774 7.68426 4.35082 7.625 4.5 7.625H5.625C5.77418 7.625 5.91726 7.68426 6.02275 7.78975C6.12824 7.89524 6.1875 8.03832 6.1875 8.1875C6.1875 8.33668 6.12824 8.47976 6.02275 8.58525C5.91726 8.69074 5.77418 8.75 5.625 8.75H4.5C4.35082 8.75 4.20774 8.69074 4.10225 8.58525C3.99676 8.47976 3.9375 8.33668 3.9375 8.1875ZM11.8125 8.1875C11.8125 8.03832 11.8718 7.89524 11.9773 7.78975C12.0827 7.68426 12.2258 7.625 12.375 7.625H13.5C13.6492 7.625 13.7923 7.68426 13.8977 7.78975C14.0032 7.89524 14.0625 8.03832 14.0625 8.1875C14.0625 8.33668 14.0032 8.47976 13.8977 8.58525C13.7923 8.69074 13.6492 8.75 13.5 8.75H12.375C12.2258 8.75 12.0827 8.69074 11.9773 8.58525C11.8718 8.47976 11.8125 8.33668 11.8125 8.1875Z"
                                                                        fill="black"
                                                                    />
                                                                </svg>
                                                            </span>

                                                            <span
                                                                className="fw-medium poppins ps-1 f-14"
                                                                role="button"
                                                            >
                                                                {
                                                                    item.drivingDuration
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="border-card-pill">
                                                        <div className="py-1 px-2">
                                                            <span>
                                                                <svg
                                                                    width="14"
                                                                    height="16"
                                                                    viewBox="0 0 14 16"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M10.9375 0.1875H3.0625C2.46576 0.1875 1.89347 0.424553 1.47151 0.84651C1.04955 1.26847 0.8125 1.84076 0.8125 2.4375V11.4375C0.8125 12.0342 1.04955 12.6065 1.47151 13.0285C1.89347 13.4504 2.46576 13.6875 3.0625 13.6875H3.625L2.6125 15.0375C2.56818 15.0966 2.53593 15.1638 2.5176 15.2354C2.49927 15.307 2.49521 15.3814 2.50565 15.4545C2.5161 15.5277 2.54085 15.598 2.57848 15.6616C2.61612 15.7252 2.6659 15.7807 2.725 15.825C2.78409 15.8693 2.85134 15.9016 2.9229 15.9199C2.99446 15.9382 3.06892 15.9423 3.14205 15.9318C3.21518 15.9214 3.28553 15.8967 3.34909 15.859C3.41265 15.8214 3.46818 15.7716 3.5125 15.7125L5.03125 13.6875H8.96875L10.4875 15.7125C10.577 15.8318 10.7103 15.9107 10.858 15.9318C11.0056 15.9529 11.1557 15.9145 11.275 15.825C11.3943 15.7355 11.4732 15.6022 11.4943 15.4545C11.5154 15.3069 11.477 15.1568 11.3875 15.0375L10.375 13.6875H10.9375C11.5342 13.6875 12.1065 13.4504 12.5285 13.0285C12.9504 12.6065 13.1875 12.0342 13.1875 11.4375V2.4375C13.1875 1.84076 12.9504 1.26847 12.5285 0.84651C12.1065 0.424553 11.5342 0.1875 10.9375 0.1875ZM1.9375 6.9375V4.125H6.4375V6.9375H1.9375ZM7.5625 4.125H12.0625V6.9375H7.5625V4.125ZM3.0625 1.3125H10.9375C11.2359 1.3125 11.522 1.43103 11.733 1.642C11.944 1.85298 12.0625 2.13913 12.0625 2.4375V3H1.9375V2.4375C1.9375 2.13913 2.05603 1.85298 2.267 1.642C2.47798 1.43103 2.76413 1.3125 3.0625 1.3125ZM10.9375 12.5625H3.0625C2.76413 12.5625 2.47798 12.444 2.267 12.233C2.05603 12.022 1.9375 11.7359 1.9375 11.4375V8.0625H12.0625V11.4375C12.0625 11.7359 11.944 12.022 11.733 12.233C11.522 12.444 11.2359 12.5625 10.9375 12.5625ZM4.75 10.5938C4.75 10.7606 4.70052 10.9238 4.6078 11.0625C4.51509 11.2013 4.38331 11.3094 4.22914 11.3733C4.07496 11.4371 3.90531 11.4538 3.74164 11.4213C3.57797 11.3887 3.42763 11.3084 3.30963 11.1904C3.19163 11.0724 3.11127 10.922 3.07871 10.7584C3.04616 10.5947 3.06287 10.425 3.12673 10.2709C3.19059 10.1167 3.29873 9.98491 3.43749 9.8922C3.57624 9.79949 3.73937 9.75 3.90625 9.75C4.13003 9.75 4.34464 9.83889 4.50287 9.99713C4.66111 10.1554 4.75 10.37 4.75 10.5938ZM10.9375 10.5938C10.9375 10.7606 10.888 10.9238 10.7953 11.0625C10.7026 11.2013 10.5708 11.3094 10.4166 11.3733C10.2625 11.4371 10.0928 11.4538 9.92914 11.4213C9.76547 11.3887 9.61513 11.3084 9.49713 11.1904C9.37913 11.0724 9.29877 10.922 9.26621 10.7584C9.23366 10.5947 9.25037 10.425 9.31423 10.2709C9.37809 10.1167 9.48623 9.98491 9.62499 9.8922C9.76374 9.79949 9.92687 9.75 10.0938 9.75C10.3175 9.75 10.5321 9.83889 10.6904 9.99713C10.8486 10.1554 10.9375 10.37 10.9375 10.5938Z"
                                                                        fill="black"
                                                                    />
                                                                </svg>
                                                            </span>

                                                            <span
                                                                className="fw-medium poppins px-1 f-14"
                                                                role="button"
                                                            >
                                                                {
                                                                    item.transitDuration
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="border-card-pill ">
                                                        <div className="py-1 px-2 ">
                                                            <span>
                                                                <svg
                                                                    width="18"
                                                                    height="19"
                                                                    viewBox="0 0 18 19"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M11.2501 3.3125C11.2501 2.86749 11.1181 2.43248 10.8709 2.06247C10.6237 1.69246 10.2723 1.40407 9.86114 1.23377C9.45001 1.06347 8.99761 1.01892 8.56115 1.10573C8.1247 1.19255 7.72378 1.40684 7.40912 1.72151C7.09445 2.03618 6.88016 2.43709 6.79334 2.87355C6.70652 3.31001 6.75108 3.7624 6.92138 4.17354C7.09168 4.58467 7.38006 4.93607 7.75007 5.18331C8.12008 5.43054 8.5551 5.5625 9.00011 5.5625C9.59684 5.5625 10.1691 5.32545 10.5911 4.90349C11.0131 4.48153 11.2501 3.90924 11.2501 3.3125ZM9.00011 4.4375C8.7776 4.4375 8.5601 4.37152 8.37509 4.2479C8.19009 4.12429 8.04589 3.94859 7.96074 3.74302C7.87559 3.53745 7.85332 3.31125 7.89672 3.09302C7.94013 2.8748 8.04728 2.67434 8.20461 2.51701C8.36195 2.35967 8.5624 2.25253 8.78063 2.20912C8.99886 2.16571 9.22506 2.18799 9.43063 2.27314C9.63619 2.35829 9.81189 2.50248 9.93551 2.68748C10.0591 2.87249 10.1251 3.09 10.1251 3.3125C10.1251 3.61087 10.0066 3.89702 9.7956 4.108C9.58462 4.31897 9.29848 4.4375 9.00011 4.4375ZM15.3521 9.92539L12.1761 6.32399C11.965 6.08462 11.7053 5.89293 11.4143 5.76164C11.1234 5.63035 10.8078 5.56247 10.4886 5.5625H7.51159C7.19239 5.56247 6.87684 5.63035 6.58589 5.76164C6.29494 5.89293 6.03526 6.08462 5.82409 6.32399L2.64808 9.92539C2.39015 10.1892 2.24622 10.5438 2.24732 10.9127C2.24842 11.2816 2.39445 11.6353 2.65394 11.8976C2.91342 12.1598 3.26557 12.3096 3.63447 12.3146C4.00337 12.3196 4.35946 12.1795 4.62597 11.9244L5.77206 11.0047L4.60909 15.4259C4.45506 15.7658 4.44234 16.1529 4.57374 16.5022C4.70514 16.8514 4.9699 17.1341 5.30976 17.2882C5.64962 17.4422 6.03675 17.4549 6.38598 17.3235C6.73522 17.1921 7.01795 16.9274 7.17198 16.5875L9.00011 13.4326L10.8282 16.5875C10.9891 16.916 11.2717 17.1688 11.6159 17.2924C11.9602 17.4159 12.339 17.4005 12.6721 17.2494C13.0052 17.0983 13.2663 16.8233 13.4 16.4829C13.5337 16.1425 13.5295 15.7633 13.3883 15.4259L12.2282 11.0047L13.3742 11.9244C13.6408 12.1795 13.9968 12.3196 14.3657 12.3146C14.7346 12.3096 15.0868 12.1598 15.3463 11.8976C15.6058 11.6353 15.7518 11.2816 15.7529 10.9127C15.754 10.5438 15.6101 10.1892 15.3521 9.92539ZM14.5428 11.1045C14.5167 11.1307 14.4857 11.1514 14.4516 11.1656C14.4174 11.1797 14.3808 11.187 14.3439 11.187C14.3069 11.187 14.2703 11.1797 14.2362 11.1656C14.202 11.1514 14.171 11.1307 14.1449 11.1045C14.1301 11.0905 14.1153 11.0764 14.0992 11.0638L11.6017 9.06125C11.5095 8.98768 11.3965 8.94493 11.2787 8.93906C11.1609 8.93319 11.0443 8.9645 10.9453 9.02855C10.8462 9.0926 10.7698 9.18615 10.7269 9.29599C10.6839 9.40583 10.6766 9.52639 10.7059 9.64063L12.3146 15.7578C12.3229 15.7904 12.3342 15.8222 12.3484 15.8527C12.3646 15.8863 12.374 15.9227 12.376 15.96C12.3781 15.9972 12.3727 16.0344 12.3602 16.0695C12.3477 16.1046 12.3283 16.1369 12.3032 16.1645C12.2781 16.1921 12.2478 16.2144 12.214 16.2301C12.1803 16.2459 12.1437 16.2547 12.1064 16.2562C12.0692 16.2577 12.032 16.2518 11.9971 16.2388C11.9622 16.2258 11.9302 16.206 11.903 16.1805C11.8758 16.155 11.8539 16.1244 11.8386 16.0904C11.8317 16.0752 11.824 16.0604 11.8154 16.0461L9.48667 12.0313C9.43722 11.946 9.36625 11.8753 9.28086 11.8261C9.19547 11.7769 9.09865 11.751 9.00011 11.751C8.90156 11.751 8.80475 11.7769 8.71936 11.8261C8.63396 11.8753 8.56299 11.946 8.51355 12.0313L6.18761 16.0426C6.17904 16.0569 6.17129 16.0717 6.1644 16.0869C6.14878 16.1204 6.12671 16.1505 6.09944 16.1755C6.07218 16.2004 6.04025 16.2198 6.0055 16.2324C5.9532 16.2516 5.89638 16.2548 5.84225 16.2416C5.78812 16.2285 5.73912 16.1995 5.70146 16.1585C5.6638 16.1174 5.63918 16.0661 5.63072 16.0111C5.62226 15.956 5.63034 15.8997 5.65394 15.8492C5.6681 15.8187 5.6794 15.7869 5.68769 15.7543L7.29433 9.64063C7.32363 9.52639 7.31628 9.40583 7.27333 9.29599C7.23037 9.18615 7.15398 9.0926 7.05495 9.02855C6.95592 8.9645 6.83927 8.93319 6.72148 8.93906C6.60368 8.94493 6.49072 8.98768 6.39854 9.06125L3.90104 11.0638C3.88487 11.0764 3.87011 11.0905 3.85534 11.1045C3.82951 11.1318 3.79848 11.1536 3.7641 11.1686C3.72971 11.1837 3.69266 11.1917 3.65512 11.1922C3.61758 11.1927 3.58032 11.1857 3.54554 11.1716C3.51075 11.1575 3.47914 11.1366 3.45258 11.11C3.42601 11.0835 3.40502 11.0519 3.39084 11.0172C3.37667 10.9824 3.3696 10.9452 3.37004 10.9076C3.37049 10.8701 3.37845 10.833 3.39345 10.7986C3.40844 10.7642 3.43018 10.7331 3.45737 10.7073C3.46581 10.6988 3.47354 10.6904 3.48128 10.6813L6.66784 7.06789C6.77346 6.94827 6.90331 6.85249 7.04879 6.78691C7.19426 6.72133 7.35202 6.68744 7.51159 6.6875H10.4886C10.6482 6.68744 10.806 6.72133 10.9514 6.78691C11.0969 6.85249 11.2268 6.94827 11.3324 7.06789L14.5189 10.6813C14.5267 10.6904 14.5344 10.6988 14.5428 10.7073C14.5954 10.76 14.625 10.8314 14.625 10.9059C14.625 10.9804 14.5954 11.0518 14.5428 11.1045Z"
                                                                        fill="black"
                                                                    />
                                                                </svg>
                                                            </span>

                                                            <span
                                                                className="fw-medium poppins px-1 f-14"
                                                                role="button"
                                                            >
                                                                {
                                                                    item.walkingDuration
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {item.services
                                                    .slice(0, 4)
                                                    .map((service, index) => (
                                                        <div
                                                            className="d-flex justify-content-between pt-1"
                                                            key={index}
                                                        >
                                                            <div>
                                                                <span className="poppins f-14 fw-medium lh-24">
                                                                    {
                                                                        service?.name
                                                                    }
                                                                </span>
                                                                <span className="px-2 poppins align-items-center ">
                                                                    <span className="dot"></span>
                                                                </span>
                                                                <span className="poppins c-667085 lh-20 f-14  link-color">
                                                                    {
                                                                        formatDuration(service?.duration)
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <span
                                                                    className="
                        poppins fw-medium f-14"
                                                                >
                                                                    £
                                                                    {
                                                                        service.price
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ))}
                            </>
                        )}
                        {isLoadingMore && (
                            <div className="d-flex justify-content-center py-4">
                                <Spin />
                            </div>
                        )}
                        {!isLoadingMore &&
                            searchPagination?.totalPages > page && (
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="border-b border-0 px-3 py-2 bg-transparent text-decoration-underline mb-4"
                                        disabled={isLoadingMore}
                                        onClick={() =>
                                            dispatch({ type: LOAD_MORE })
                                        }
                                    >
                                        Load more
                                    </button>
                                </div>
                            )}
                    </div>

                    <div className="row d-flex col-12 col-lg-5 mb-5 mt-3">
                        <div className="ms-3 mt-lg-5">
                            <Mapcomponent list={locationList} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppointmentSearch;
